import React, { forwardRef, useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import API from '../../API';
import parse from 'html-react-parser';
import '../../App.css';
import { GradeLevelName, DateThai, GetAPIURL } from '../../Utils/Function';
import { PDFViewCard } from '../../Components';

import RegisterView from './Application/RegisterView';
import RegisterForm from './Application/RegisterForm';
const ProjectContent = forwardRef((props, ref) => {
    const RedirectTo = useNavigate()
    const [_ProjectList, setProjectList] = useState([]);
    const [_Application, setApplication] = useState(null);
    const _RegisterForm = useRef();
    const _PDFViewCard = useRef();
    const _RegisterView = useRef();
    useEffect(() => {
        (async () => {
            _GetProjectList();
        })();

        return () => { }
    }, []);

    const _GetProjectList = async () => {
        setProjectList([]);
        setApplication(null);
        API({ method: "get", url: "/Member/Project" }).then(res => {
            if (res.data.Status) {
                setProjectList(res.data.Projects);

            } else {
                Swal.fire({
                    icon: 'error',
                    title: res.data.Message,
                });
            }
        }).catch(error => {

        });
    }
    const _PDFView = async (ProjectID, Title) => {
        _PDFViewCard.current?.Show(GetAPIURL() + "/Member/Project/" + ProjectID + "/" + sessionStorage.getItem("Authorization") + "/PDF", Title);

    }
    const _ApplicationView = async (ApplicationID, Title) => {
        _PDFViewCard.current?.Show(GetAPIURL() + "/Application/" + ApplicationID + "/" + sessionStorage.getItem("Authorization") + "/PDF", Title);

    }
    const _CandidateView = async (ApplicationID, Title) => {
        _PDFViewCard.current?.Show(GetAPIURL() + "/Application/" + ApplicationID + "/" + sessionStorage.getItem("Authorization") + "/Candidate", Title);

    }
    const _ApplicationCancel = async (ApplicationID) => {

        Swal.fire({
            icon: 'warning',
            title: 'ต้องการยกเลิกใบสมัครหรือไม่ ?',
            text: '',
            showCancelButton: true,
            confirmButtonText: 'ยืนยัน',
            confirmButtonColor: '#d33',
            cancelButtonText: 'ยกเลิก'
        }).then((r) => {
            if (!r.isConfirmed) {
                return;
            }

            API({ method: "delete", url: "/Application/" + ApplicationID + '/Cancel'}).then(res => {
                if (!res.data.Status) {
                    Swal.fire({
                        icon: 'error',
                        title: res.data.Message
                    });
                    return;
                }
                _GetProjectList();
            }).catch(res => {
                if (res.response.data != undefined) {
                    Swal.fire({
                        icon: 'error',
                        title: res.code,
                        text: res.response.data.Message
                    });
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'การเชื่อมต่อผิดพลาด',
                        text: res.message + ' [' + res.code + ']',
                    });
                }
            });
        });
    }
    return (
        <>
            {_ProjectList.map((item, index) => {
                return (
                    <div className='row' key={index}>
                        <div className='col-12 mb-4'>
                            <div className='card'>
                                <div className='card-body' style={{ 'backgroundColor': '#edf8ff' }}>
                                    <div className='row justify-content-between mb-2'>
                                        <div className='col-lg-6 mt-2 mb-2 fw-semibold col-lg-2 d-block d-sm-block d-md-none mt-2 mb-2 text-start'>{item.ProjectName}</div>
                                        <div className='col-lg-6 col-md-8 mt-2 mb-2 fw-semibold fs-5 d-none d-sm-none d-md-block mt-2 mb-2'>{item.ProjectName}</div>
                                        <div className='col-lg-6 col-12 text-end col-md-4'>
                                            <div className='btn btn-group btn-group-lg'>
                                                <button className='btn btn-info text-white' onClick={() => { _PDFView(item.ProjectID, item.ProjectName); }}>ระเบียบการ</button>
                                                {(item.Appliation != null && item.Appliation.Edit && item.Active === true ?
                                                    <button className='btn btn-warning text-white' onClick={() => { (item.Application != null ? _RegisterForm.current.Show(item.ProjectID, item.Appliation.ApplicationID) : _RegisterForm.current.Show(item.ProjectID, null)) }}>แก้ไขข้อมูลการสมัคร</button>
                                                    : "")}
                                                {(item.Active === true && item.Status === 1 ?
                                                    <button className='btn btn-danger text-white' onClick={() => { (item.Application != null ? _RegisterForm.current.Show(item.ProjectID, item.Appliation.ApplicationID) : _RegisterForm.current.Show(item.ProjectID, null)) }}>กรอกใบสมัคร</button>
                                                    : "")}
                                                {(item.Appliation != null && item.Appliation.View ?
                                                    <button className='btn btn-success text-white' onClick={() => { _ApplicationView(item.Appliation.ApplicationID, 'ข้อมูลใบสมัครสอบคัดเลือก') }}>รายละเอียด</button>
                                                    : "")}

                                                {(item.Appliation != null && item.Appliation.Cancel ?
                                                    <button className='btn btn-warning text-white' onClick={() => { _ApplicationCancel(item.Appliation.ApplicationID); }}>ยกเลิก</button>
                                                    : "")}    
                                                {(item.Appliation != null && item.Appliation.Candidate ?
                                                    <button className='btn btn-primary text-white' onClick={() => { _CandidateView(item.Appliation.ApplicationID, 'บัตรประจำตัวผู้สมัครสอบ') }}>บัตรประจำตัวผู้สมัคร</button>
                                                    : "")}
                                            </div>
                                        </div>

                                        {(item.Status != 0 ? <>
                                            <div className='row'>
                                                <div className='col-lg-2 d-block d-sm-block d-md-none mt-2 mb-2 text-start'>สถานะ : </div>
                                                <div className='col-lg-2 d-none d-sm-none d-md-block mt-2 mb-2 text-end'>สถานะ : </div>
                                                <div className='col-lg-3 mt-2 mb-2'>
                                                    <span className="badge bg-primary text-white" style={{ 'minWidth': '150px', 'minHeight': '34px' }}><label style={{ 'paddingTop': '5px', 'fontSize': '16px' }}>{(item.StatusName)}</label></span>
                                                </div>
                                            </div>
                                        </> : "")}

                                        {(item.ApplicationID != null && item.CandidateCode != null ?
                                            <div className='row'>
                                                <div className='col-lg-2 d-block d-sm-block d-md-none mt-2 mb-2 text-start'>
                                                    <span className='fw-semibold'>หมายเลขประจำตัวผู้สมัคร :</span>
                                                </div>
                                                <div className='col-lg-2 d-none d-sm-none d-md-block mt-2 mb-2 text-end'>
                                                    <span className='fw-semibold'>เลขประจำตัวผู้สมัคร :</span>
                                                </div>
                                                <div className='col-lg-10 mt-2 mb-2'>{item.CandidateCode}</div>
                                            </div>
                                            : "")}

                                        <div className='row'>
                                            <div className='col-lg-2 d-block d-sm-block d-md-none mt-2 mb-2 text-start'>
                                                <span className='fw-semibold'>ระดับชั้น :</span>
                                            </div>
                                            <div className='col-lg-2 d-none d-sm-none d-md-block mt-2 mb-2 text-end'>
                                                <span className='fw-semibold'>ระดับชั้น :</span>
                                            </div>
                                            <div className='col-lg-3 mt-2 mb-2'><span className='ml-2'>{GradeLevelName(item.GradeLevel)}</span></div>
                                        </div>

                                        <div className='row'>
                                            <div className='col-lg-2 d-block d-sm-block d-md-none mt-2 mb-2 text-start'>
                                                <span className='fw-semibold'>รับระเบียบการ :</span>
                                            </div>
                                            <div className='col-lg-2 d-none d-sm-none d-md-block mt-2 mb-2 text-end'>
                                                <span className='fw-semibold'>รับระเบียบการ :</span>
                                            </div>
                                            <div className='col-lg-10 mt-2 mb-2'>
                                                {DateThai(item.ApplicationStart)} - {DateThai(item.ApplicationEnd)}
                                            </div>
                                        </div>


                                        <div className='row'>
                                            <div className='col-lg-2 d-block d-sm-block d-md-none mt-2 mb-2 text-start'>
                                                <span className='fw-semibold'>รับสมัคร :</span>
                                            </div>
                                            <div className='col-lg-2 d-none d-sm-none d-md-block mt-2 mb-2 text-end'>
                                                <span className='fw-semibold'>รับสมัคร :</span>
                                            </div>
                                            <div className='col-lg-10 mt-2 mb-2'>
                                                {DateThai(item.SubmitStart)} - {DateThai(item.SubmitEnd)}
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-lg-2 d-block d-sm-block d-md-none mt-2 mb-2 text-start'>
                                                <span className='fw-semibold'>ประกาศรายชื่อผู้มีสิทธิ์สอบ :</span>
                                            </div>
                                            <div className='col-lg-2 d-none d-sm-none d-md-block mt-2 mb-2 text-end'>
                                                <span className='fw-semibold'>ประกาศรายชื่อผู้มีสิทธิ์สอบ :</span>
                                            </div>
                                            <div className='col-lg-10 mt-2 mb-2'>
                                                {DateThai(item.Candidate)}
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-lg-2 d-block d-sm-block d-md-none mt-2 mb-2 text-start'>
                                                <span className='fw-semibold'>สอบคัดเลือก :</span>
                                            </div>
                                            <div className='col-lg-2 d-none d-sm-none d-md-block mt-2 mb-2 text-end'>
                                                <span className='fw-semibold'>สอบคัดเลือก :</span>
                                            </div>
                                            <div className='col-lg-10 mt-2 mb-2'>
                                                {DateThai(item.ExamStart)}
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-lg-2 d-block d-sm-block d-md-none mt-2 mb-2 text-start'>
                                                <span className='fw-semibold'>ประกาศผล :</span>
                                            </div>
                                            <div className='col-lg-2 d-none d-sm-none d-md-block mt-2 mb-2 text-end'>
                                                <span className='fw-semibold'>ประกาศผล :</span>
                                            </div>
                                            <div className='col-lg-10 mt-2 mb-2'>
                                                {DateThai(item.ExamResult)}
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-lg-2 d-block d-sm-block d-md-none mt-2 mb-2 text-start'>
                                                <span className='fw-semibold'>ยืนยันสิทธิ์ :</span>
                                            </div>
                                            <div className='col-lg-2 d-none d-sm-none d-md-block mt-2 mb-2 text-end'>
                                                <span className='fw-semibold'>ยืนยันสิทธิ์ :</span>
                                            </div>
                                            <div className='col-lg-10 mt-2 mb-2'>
                                                {DateThai(item.ConfirmDate)}
                                            </div>
                                        </div>
                                        {(item.Description != null ?
                                            <>
                                                <div className='row mt-2'>
                                                    <div className='col-lg-2 d-block d-sm-block d-md-none mt-2 mb-2 text-start'>
                                                        <span className='fw-semibold'>รายละเอียด :</span>
                                                    </div>
                                                    <div className='col-lg-2 d-none d-sm-none d-md-block mt-2 mb-2 text-end'>
                                                        <span className='fw-semibold'>รายละเอียด :</span>
                                                    </div>
                                                    <div className='col-lg-10 mt-2 mb-2'>
                                                        {parse(item.Description)}
                                                    </div>
                                                </div>
                                            </>
                                            : "")}
                                        <div className='row'>
                                            <div className='col-lg-2 d-block d-sm-block d-md-none mt-2 mb-2 text-start'>
                                                <span className='fw-semibold'>หลักสูตร :</span>
                                            </div>
                                            <div className='col-lg-2 d-none d-sm-none d-md-block mt-2 mb-2 text-end'>
                                                <span className='fw-semibold'>หลักสูตร :</span>
                                            </div>
                                            <div className='col-lg-10 mt-2 mb-2'>
                                                {item.Courses.map((course, cindex) => (
                                                    <>
                                                        <div className='row' key={cindex}>
                                                            <div className='col-12'>
                                                                - {course.Course.CourseName} (รับ {course.SeatLimit} คน)
                                                            </div>
                                                        </div>
                                                    </>
                                                ))}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );

            })}
            <RegisterForm ref={_RegisterForm} reload={() => { _GetProjectList() }} />
            <PDFViewCard ref={_PDFViewCard} />

        </>
    )
});
export default React.memo(ProjectContent)